<template>
  <v-card :class="typeModalResource">
    <v-card-title class="modal">
      <v-spacer></v-spacer>
      <i @click="closeModal()" class="icon-close" ></i>
    </v-card-title>
    <v-card-text style="height: 700px;" id="resourceModal">
      <v-container :fluid="true">
        <v-row  class="d-flex justify-content-center" style="justify-content: center;">
          <v-col sm="8" md="5" cols="12" style="text-align:center">
            <audio v-show="playAudio" ref="playAudio" controls style="width: 100%;">
              <source :src="playAudio" type="audio/mp3">
            </audio>
            <video v-show="playVideo" ref="playVideo" width="100%" height="auto" controls>
              <source :src="playVideo" type="video/mp4">
            </video>
            <div>
              <v-btn @click.stop="closeVideoAudio()" icon fab small color="#ff2929" dark v-show="playVideo || playAudio">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </div>
            
          </v-col>
        </v-row>
        <v-row>
          <!--FILTROS-->
          <v-col v-show="config.comboComponente" class="d-flex input" cols="12" sm="4">
            <v-select  v-model="selectLMTemp" @click:clear="clearLM()" :clearable="true" :return-object="true" @input="hasValue($event, 'LM')" :items="showLM" :label="literal['RECURSOS']['COMPONENTE']"></v-select>
          </v-col>
          <v-col v-show="!config.comboUnidad" cols="12" sm="4">
          </v-col>
          <v-col v-show="config.comboUnidad" class="d-flex input" cols="12" sm="4">
            <v-select @click:clear="clearUnit()" :clearable="true" :return-object="true" @input="hasValue($event, 'Unit')" :items="showUnit" :label="literal['RECURSOS']['UNIDAD']" :disabled="selectLM == -1"></v-select>
          </v-col>
          <v-col v-show="!config.comboComponente" cols="12" sm="4">
          </v-col>
          <v-col v-if="config.comboTipoRecurso" class="d-flex input" cols="12" sm="4">
            <v-select @click:clear="clearTR()" :clearable="true" :return-object="true" @input="hasValue($event, 'Type')" :items="showTR" :label="literal['RECURSOS']['TIPO']" :disabled="selectUnit == -1"></v-select>
          </v-col>
          <!--FIN FILTROS-->

          <!--BUSCADOR-->
          <v-col class="d-flex input offset-sm-8" cols="12" sm="4">
            <v-text-field @keyup.enter="buscador" 
                        v-model="textBuscar" 
                        :label="literal['RECURSOS']['BUSCAR']" 
                        hide-details="auto"
                        @click:append="buscador"
                        append-icon="mdi-magnify">
            </v-text-field>
          </v-col>
          <!--FIN BUSCADOR-->
        </v-row>

        <!--LISTA DE BUSQUEDA-->
        <v-row>
          <v-list two-line :width="'100%'" id="listResource">
            <v-list-item-group>
              <template v-if="isFound">
                <div style="text-align:center;font-size:18px">
                  {{literal["RECURSOS"]["NO-ENCONTRADO"]}}
                </div>
                
              </template>
              <template v-for="(resource, index) in listRecurso">

                <!--LISTA DE RECURSOS-->
                <v-list-item :key="resource.title" @click="openResource(resource)" :class="{'select':(zoneDelete && resource.codRecurso == zoneDelete.recurso)}">
                  
                  <v-list-item-avatar>
                   
                    <!--TIPO DE ICONO-->
                    <v-icon v-if="resource.tipo == 'html'" class="ICONO_14"></v-icon>
                    <v-icon v-if="resource.tipo == 'pdf'" class="ICONO_26"></v-icon>
                    <v-icon v-if="resource.tipo == 'doc'" class="icon-word"></v-icon>
                    <v-icon v-if="resource.tipo == 'docx'" class="icon-word"></v-icon>
                    <v-icon v-if="resource.tipo == 'xls'" class="icon-excel"></v-icon>
                    <v-icon v-if="resource.tipo == 'xlsx'" class="icon-excel"></v-icon>
                    <v-icon v-if="resource.tipo == 'ppt'" class="icon-ppt"></v-icon>
                    <v-icon v-if="resource.tipo == 'pptx'" class="icon-ppt"></v-icon>
                    <v-icon v-if="resource.tipo == 'pps'" class="icon-ppt"></v-icon>
                    <v-icon v-if="resource.tipo == 'ppsx'" class="icon-ppt"></v-icon>
                    <v-icon v-if="resource.tipo == 'video'" class="ICONO_recursos-video"></v-icon>
                    <v-icon v-if="resource.tipo == 'audio'" class="ICONO_36"></v-icon>
                    <!--FIN TIPO DE ICONO-->

                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="resource.titulo"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!--DIVISOR-->
                <v-divider v-if="index + 1 < listRecurso.length" :key="index"></v-divider>
                <!--FIN DIVISOR-->
              </template>
            </v-list-item-group>
          </v-list>
        </v-row>
        <!--FIN LISTA DE BUSQUEDA-->
      </v-container>
      
    </v-card-text>
    <template v-if="typeModalResource == 'typeResourceEdit'">
      <template v-if="zoneDelete">
        <v-card-actions>
          <v-container>
            <v-row :justify="'center'">
              <v-col sm="3" lg="2" offset-sm="8" offset-lg="10" style="padding:0px;text-align:center">
                <v-btn @click.stop="updateZone()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ACTUALIZAR"]}}
                </v-btn>
              </v-col>
              <v-col sm="3" lg="2" style="padding:0px;text-align:center">
                <v-btn @click.stop="deleteZone()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ELIMINAR"]}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-actions>
          <v-container>
            <v-row :justify="'center'">
              <v-col sm="2" lg="1" offset-sm="8" offset-lg="10" style="padding:0px;text-align:center">
                <v-btn @click.stop="addResource" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ACEPTAR"]}}
                </v-btn>
              </v-col>
              <v-col sm="2" lg="1" style="padding:0px;text-align:center">
                <v-btn @click.stop="closeModalEdit()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["CANCELAR"]}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </template>
    </template>
    
  </v-card>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from 'vuex'

export default {
  name: "ModalResource",

  data: () => ({
    ebook: [],
    selectLM: -1,
    selectUnit: -1,
    selectTR: -1,
    allRecursos: [],
    listRecurso: null,
    textBuscar: "",
    payload: null,
    codRecurso: null,
    titulo: null,
    tipo: null,
    playAudio: null,
    playVideo: null,
    isFound: false,
    selectLMTemp:{},
    flag: true
  }),
  props: ["literal", "typeModalResource"],
  methods: {
    closeVideoAudio(){
      this.playVideo = null;
      this.playAudio = null;
      this.$refs.playAudio.pause();
      this.$refs.playVideo.pause();
    },

    deleteZone(){
      this.deleteZoneActive(this.zoneDelete.id);
      this.setModalResource(false);
    },
    updateZone(){
      this.zoneDelete.recurso = this.codRecurso;
      this.zoneDelete.titulo = this.titulo;
      this.zoneDelete.tipo = this.tipo;
      this.updateZoneActive(this.zoneDelete.id)
      this.setModalResource(false)
    },
    closeModalEdit(){
      // this.deleteZoneActive(this.zoneDelete.id)
      // this.setModalResource(false)
      
      this.setModalResource(false)
      this.setModalAddResource(true)
      this.setWidthModal(370)
    },
    closeModal(){
      this.setModalResource(false);
      this.setZoneDelete(null);
      var pageImg = document.getElementsByClassName("zonaTransparente");
      if(pageImg){
        pageImg[0].hidden = true;
        pageImg[1].hidden = true;
      }
    },
    hasValue(item, select){
      if(item){
        switch(select){
          case "LM":
            this.valueLM(item);
            break;
          case "Unit":
            this.valueUnit(item);
            break;
          case "Type":
            this.valueTR(item);
            break;
        }
      }
    },

    valueLM(item){
      this.textBuscar = '';
      this.selectLM = item.value;
      this.listRecurso = [];
      let flag = true;
      
      let unidades = this.$store.state.ebook[this.selectLM]['unidades'];
      unidades.forEach(element => {
        if(element.recursos != null){
          flag = false;
        }
      });

      //Hay 3 filtros: componente, unidad y tipo de recurso
      if(flag){
        unidades.forEach((unidad) => {

          //Se valida si existe el atributo  tipoRecursos
          if(unidad['tipoRecursos']){
            unidad['tipoRecursos'].forEach((tipo) => {

              //Se valida si existe el atributo recursos
              if(tipo['recursos']){
                tipo['recursos'].forEach((recurso) => {
                  this.listRecurso.push(recurso);
                });
              }
            });
          }
        });
      } else {  //hay 2 filtros: componente  y unidad
        unidades.forEach((unidad) => {
          
          //Se valida si existe el recursos
          if(unidad['recursos']){
            unidad['recursos'].forEach((recurso) => {
              this.listRecurso.push(recurso);
            });
          }


          
        });

        if(this.recursosGlobales) {
            this.listRecurso = this.recursosGlobales.concat(this.listRecurso);
          }
      }

    },
    valueUnit(item){
      this.textBuscar = '';
      this.selectUnit = item.value;
      this.listRecurso = [];

      let flag = true;
      let unidad = this.ebook[this.selectLM]['unidades'][this.selectUnit];

      if(!unidad['tipoRecursos']){
        flag = false;
      }

      if(flag){//Hay 3 filtros
        unidad['tipoRecursos'].forEach((tipo) => {

          //Se valida si existe el atributo recursos
          if(tipo['recursos']){
            tipo['recursos'].forEach((recurso) => {
              this.listRecurso.push(recurso);
            });
          }
        });
      } else {//Hay 2 filtros
        if(unidad['recursos']){
          unidad['recursos'].forEach((recurso) => {
            this.listRecurso.push(recurso);
          });
        }
      
      }
    },

    valueTR(item){
      this.textBuscar = '';
      this.selectTR = item.value;
      this.listRecurso = [];

      let tipo = this.ebook[this.selectLM]['unidades'][this.selectUnit]['tipoRecursos'][this.selectTR];

      if(tipo['recursos']){
        tipo['recursos'].forEach((recurso) => {
          this.listRecurso.push(recurso);
        });
      } 
    },

    clearLM(){
      this.listRecurso = [];
      this.selectLM = -1;
      this.selectUnit = -1;
      this.selectTR = -1;
      this.selectLMTemp = null;
    },

    clearUnit(){
      this.selectUnit = -1;
      this.selectTR = -1;
      let item = {value: this.selectLM}
      this.valueLM(item)
    },

    clearTR(){
      this.selectTR = -1;
      let item = {value: this.selectUnit}
      this.valueUnit(item)
    },
    
    openResource(resource){
      if (this.typeModalResource == "typeResourceView") {
        switch(resource.tipo){
          case "html":
            this.playVideo = null;
            this.playAudio = null;
            this.$refs.playAudio.pause();
            this.$refs.playVideo.pause();
            this.setModalResourceFull({isOpen: true, resource: resource.codRecurso})
            break;
          case "audio":
            this.playAudio = "recursos/AUDIOS/" + resource.codRecurso +".mp3"
            this.playVideo = null;
            this.$refs.playAudio.load()
            this.$refs.playAudio.play()
            this.$refs.playVideo.pause();
            var id = document.getElementById('resourceModal');
            id.scroll(0, 0)
            // window.open("recursos/AUDIOS/" + resource.codRecurso +".mp3", '_blank');
            break;
          case "video":
            this.playVideo = "recursos/VIDEOS/" + resource.codRecurso +".mp4";
            this.playAudio = null;
            this.$refs.playVideo.load()
            this.$refs.playVideo.play()
            this.$refs.playAudio.pause();
            var id = document.getElementById('resourceModal');
            id.scroll(0, 0)
            // window.open("recursos/VIDEOS/" + resource.codRecurso +".mp4", '_blank');
            break;
          case "pdf":
          case "ppt":
          case "xls":
          case "doc":
          case "pps":
          case "ppsx":
          case "docx":
          case "pptx":
          case "xlsx":
            this.playVideo = null;
            this.playAudio = null;
            this.$refs.playAudio.pause();
            this.$refs.playVideo.pause();
            window.open("recursos/DOCUMENTOS/" + resource.codRecurso +"." + resource.tipo, '_blank');
            break
        }
      } else {
        this.codRecurso = resource.codRecurso;
        this.titulo = resource.titulo;
        this.tipo = resource.tipo;
      }
      
    },
    addResource(){
      this.zoneTemp.data.recurso = this.codRecurso;
      this.zoneTemp.data.titulo = this.titulo;
      this.zoneTemp.data.tipo = this.tipo;
      this.payload = {page: this.zoneTemp.page, data: this.zoneTemp.data};
      this.addZoneActive(this.payload);
      this.setModalResource(false);
    },
    buscador() {
      this.selectLM = -1;
      this.selectUnit = -1;
      this.selectTR = -1;
      this.listRecurso = [];
      this.isFound = false;
      if (this.textBuscar == "") {
        return;
      }
      // this.itemsLM = null;
      // this.selectUnidad = null;
      // this.selectTipoRecurso = null;

      let valor = this.textBuscar.toUpperCase();//Valor ingresado en el buscador
      let patt = new RegExp(valor);
      let result = null;
      let temp = "";
      
      //Hace un recorrido por todos los recursos existentes
      for (let i = 0; i < this.allRecursos.length; i++) {

        //Se le pone mayuscula a los nombres de los recursos para hacer un mejor match
        temp = this.allRecursos[i].titulo.toUpperCase();
        result = temp.match(patt);

        //Si el objeto coincide con la cadena de caracteres que se ingreso
        if (result != null) {
          this.listRecurso.push(this.allRecursos[i]);
        }
      }
    
      if(this.listRecurso.length == 0){
        this.isFound = true;
      }
    },
    ...mapMutations(["setWidthModal","setModalResourceFull", "setModalResource", "setModalAddResource", "addZoneActive","setTypeModalResource", "setZoneDelete","updateZoneActive", "deleteZoneActive"]) 
  },
  computed: {
    showLM(){
      let itemsLM = [];
      this.ebook.forEach(function (element, index) {
        if(!element.desactivarRecurso){
          itemsLM.push({value: index, text: element.nombre})
        }
      });


      if(this.config.selecionarUnidadAbriModal){
        this.selectLMTemp = {value: this.$store.state.indexLM}

        if(this.flag){
          this.valueLM(this.selectLMTemp)
          
          this.flag = false;
        }
      }
      
      
      return itemsLM;
    },
    showUnit(){

      if(this.selectLM != -1 
        && this.$store.state.ebook[this.selectLM]['unidades']){
        let itemsUnit = [];
        this.$store.state.ebook[this.selectLM]['unidades'].forEach((element, index) => {
          if(element.nombre != null){
            itemsUnit.push({value: index, text: element.nombre})
          }
          
        });
        return itemsUnit;
      } else {
        this.selectLM = -1;
        return null;
      }

    },
    showTR(){
      if(this.selectUnit != -1 
        && this.ebook[this.selectLM]['unidades'][this.selectUnit]['tipoRecursos']){
        let itemsTR = [];
        this.ebook[this.selectLM]['unidades'][this.selectUnit]['tipoRecursos'].forEach((element, index) => {
          itemsTR.push({value: index, text: element.nombre})
        });
        return itemsTR;
      } else {
        this.selectUnit = -1;
        return null;
      }
    },
    ...mapState(['zoneTemp', 'zoneDelete', 'config', 'recursosGlobales'])
  },
  mounted: function () {
    this.ebook = this.$store.state.ebook;

    //Agarra todos lo recursos de los LM's
    for (let i = 0; i < this.ebook.length; i++) {
      if (this.ebook[i].unidades != null) {
        for (let j = 0; j < this.ebook[i].unidades.length; j++) {
          if (this.ebook[i].unidades[j].tipoRecursos != null) {
            for (let k = 0; k < this.ebook[i].unidades[j].tipoRecursos.length; k++) {
              for (let l = 0; l < this.ebook[i].unidades[j].tipoRecursos[k].recursos.length; l++) {
                this.allRecursos.push(
                  this.ebook[i].unidades[j].tipoRecursos[k].recursos[l]
                );
              }
            }
          } else if(this.ebook[i].unidades[j].recursos) {
            for (let k = 0; k < this.ebook[i].unidades[j].recursos.length; k++) {
              this.allRecursos.push(
                this.ebook[i].unidades[j].recursos[k]
              );
            }
          }
        }
      }
    }
    if(this.recursosGlobales) {
      this.allRecursos = this.recursosGlobales.concat(this.allRecursos);
    }

    if(!this.config.selecionarUnidadAbriModal){
      this.listRecurso = this.allRecursos;
    }
    
  },
};
</script>

<style>
.editar {
  color: #f0a656 !important;
}
.d-flex.input {
  padding-top: 0px;
  padding-bottom: 0px;
}
#listResource i{
  font-size:32px;
}

.v-input__icon--clear button{
  height: 100%;
  margin-top: 15px;
}

button.v-icon.mdi-magnify{
  color:white !important;
  background-color: #32B6FF;
}
</style>
